import styled from "@emotion/styled";
import Loader from "./icons/Loader";

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0 0 0;
  margin: 0 0 0 0;
  text-align: center;
  width: auto;
`;

const Loading = ({ className }: { className?: string }) => (
  <LoadingContainer className={className} data-testid="loading">
    <Loader />
  </LoadingContainer>
);

export const PageLoading = styled(Loading)`
  height: 100vh;
`;

export default Loading;
